/** Gemeinsame Typen und Beschriftungen der Personalverwaltung. */

export interface Qualifikation {
  id: number | null
  typ: string
  nummer: string | null
  gueltigVon: string | null
  gueltigBis: string | null
  tageBisAblauf: number | null
  gueltig: boolean
  pflicht: boolean
  bemerkung: string | null
}

export interface Kursberechtigung {
  id: number | null
  kursnummer: string
  art: string
  eingewiesenAm: string | null
  bemerkung: string | null
}

export interface Abwesenheit {
  id: number
  art: string
  von: string
  bis: string
  status: string
  bemerkung: string | null
  tage: number
}

export interface Fahrer {
  id: number
  personalnummer: string
  vorname: string
  nachname: string
  geburtsdatum: string | null
  eintritt: string | null
  austritt: string | null
  email: string | null
  telefon: string | null
  betriebshofId: number | null
  betriebshofName: string | null
  teamId: number | null
  teamName: string | null
  teamFarbe: string | null
  wochenarbeitszeitMinuten: number | null
  aktiv: boolean
  /** Fährt dieser Mitarbeiter? Werkstatt und Büro stehen in der Liste, planen aber nicht mit. */
  istFahrer: boolean
  einsatzbereit: boolean
  heuteAbwesend: boolean
  qualifikationen: Qualifikation[]
  kursberechtigungen: Kursberechtigung[]
  abwesenheiten: Abwesenheit[]
  einsetzbarAufKursen: string[]
  /** Fehlt bei einem noch nicht gespeicherten Fahrer. */
  app?: AppStatus
}

/** Der Stand der Fahrer-App: wem sie freigeschaltet ist und wer sie in Betrieb hat. */
export interface AppStatus {
  zugangVorhanden: boolean
  freigeschaltet: boolean
  geraetGekoppelt: boolean
  aktiviertAm: string | null
  letzteNutzung: string | null
  geraetename: string | null
  codeOffen: boolean
}

export interface Team {
  id: number
  kuerzel: string
  name: string
  beschreibung: string | null
  farbe: string | null
  betriebshofId: number | null
  betriebshofName: string | null
  kursnummern: string[]
  anzahlFahrer: number
  aktiv: boolean
}

export interface Kandidat {
  fahrerId: number
  personalnummer: string
  name: string
  teamName: string | null
  verfuegbar: boolean
  ueberTeam: boolean
  grund: string | null
}

export const QUALIFIKATIONSTYPEN = [
  { wert: 'FAHRERLAUBNIS_D', text: 'Fahrerlaubnis D', pflicht: true },
  { wert: 'CODE_95', text: 'Code 95 (BKrFQG)', pflicht: true },
  { wert: 'AERZTLICHE_UNTERSUCHUNG', text: 'Ärztliche Untersuchung', pflicht: true },
  { wert: 'AUGENAERZTLICHE_UNTERSUCHUNG', text: 'Augenärztliche Untersuchung', pflicht: true },
  { wert: 'FAHRERKARTE', text: 'Fahrerkarte', pflicht: false },
  { wert: 'UNTERWEISUNG', text: 'Unterweisung', pflicht: false },
  { wert: 'SONSTIGE', text: 'Sonstige', pflicht: false },
]

export const QUALIFIKATION_KURZ: Record<string, string> = Object.fromEntries(
  QUALIFIKATIONSTYPEN.map((q) => [q.wert, q.text]),
)

export const ABWESENHEITSARTEN = [
  { wert: 'URLAUB', text: 'Urlaub' },
  { wert: 'KRANKHEIT', text: 'Krankheit' },
  { wert: 'SCHULUNG', text: 'Schulung' },
  { wert: 'FREIZEITAUSGLEICH', text: 'Freizeitausgleich' },
  { wert: 'SONSTIGE', text: 'Sonstige' },
]

export const ABWESENHEIT_TEXT: Record<string, string> = Object.fromEntries(
  ABWESENHEITSARTEN.map((a) => [a.wert, a.text]),
)

export const STATUS_TEXT: Record<string, string> = {
  BEANTRAGT: 'beantragt',
  GENEHMIGT: 'genehmigt',
  ABGELEHNT: 'abgelehnt',
}

export const STATUS_ETIKETT: Record<string, string> = {
  BEANTRAGT: 'orange',
  GENEHMIGT: 'gruen',
  ABGELEHNT: 'grau',
}

/** Farbe für eine Frist: rot wenn abgelaufen, orange wenn bald fällig. */
export function fristKlasse(gueltig: boolean, tageBisAblauf: number | null): string {
  if (!gueltig) return 'rot'
  if (tageBisAblauf !== null && tageBisAblauf < 60) return 'orange'
  return 'grau'
}
